module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/header-image-04-73d4621076d9b67907dffdbaa5d1e913.jpg";